import axios from '../../../axiosInstance';

export const getCurrencies = () => {
  return axios.get(`/iso/currencies`);
};
